<template>
  <modal
    :show.sync="isShowModal"
    modal-classes="modal-secondary"
    :backdrop-close="true"
    size="lg"
    @close="close()"
  >
    <h6 slot="header" class="modal-title text-uppercase">Add Reward</h6>
    <validation-observer ref="formValidator">
      <div class="row">
        <div class="col-md-6">
          <base-input
            v-model="formGroup.token_count.value"
            :rules="formGroup.token_count.rule"
            label="Token Count"
            name="token_count"
            placeholder="Enter Token Count"
          ></base-input>
        </div>

        <div class="col-md-6">
          <base-selectbox
            v-model="formGroup.type.value"
            :rules="formGroup.type.rule"
            :options="source.status"
            placeholder="Select Type"
            label="Type"
            name="type"
            size="small"
          ></base-selectbox>
        </div>
      </div>
    </validation-observer>
    <template v-slot:footer>
      <base-button type="primary" :loading="loading" @click="saveReward">
        Submit
      </base-button>
      <base-button
        class="ml-auto"
        type="primary"
        :outline="true"
        @click="close()"
      >
        Close
      </base-button>
    </template>
  </modal>
</template>

<script>
import { FormGroup } from "@/core/models";
import { membersService, notificationService } from "@/core/services";

export default {
  props: {
    showAddInvitaitionModalForm: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      modalState: false,
      formGroup: new FormGroup({
        user_id: this.item.id,
        token_count: [null, { required: true }],
        type: [null, { required: true }],
      }),
      source: {
        status: [
          { label: "Referral", value: "referral" },
          { label: "Own Flight", value: "own_flight" },
          { label: "Refund", value: "refund" },
          { label: "Customer Support", value: "customer_support" },
          { label: "Bonus", value: "bonus" },
        ],
      },
      loading: false,
    };
  },
  computed: {
    isShowModal: {
      get() {
        return this.showAddInvitaitionModalForm;
      },
      set(value) {
        this.modalState = value;
      },
    },
  },
  methods: {
    async saveReward() {
      const validate = await this.$refs.formValidator.validate();
      if (validate) {
        console.log(this.formGroup.value);
        this.loading = true;
        let obj = {
          user_id: this.item.id,
          token_count: this.formGroup.token_count.value,
          type: this.formGroup.type.value,
        };
        membersService
          .saveReward(obj)
          .then((res) => {
            notificationService.success(res.message);
            this.$store.commit("member/updateRewards", {
              id: this.item.id,
              response: res.data,
            });
            this.close();
          })
          .finally(() => (this.loading = false));
      }
    },
    close() {
      this.isShowModal = false;
      this.$emit("close");
      this.$refs.formValidator.reset();
      this.formGroup.reset();
      //console.log(this.formGroup);
    },
  },
};
</script>

<style lang="scss" scoped>
.heading-separator {
  border-bottom: 1px solid #968888;
  margin-bottom: 1.5em;
  margin-top: 1em;
}
</style>
